import Scriba from 'react-scriba';

export const NIVEAUX_ALERTES = {
    option: 1,
    leveeOption: 2,
    reservation: 3,
    desistement: 4,
    dedoublementContact: 5,
    envoiDocument: 6,
    echeanceOption: 7,
    gestionDocument: 8,
    signaturesClients: 9,
    aSignerEiffage: 10,
    signerEiffage: 11,
    modifierContact: 12,
    messageInstantane: 13
};

export class DataNiveauAlerte {

    static _chargementNiveauAlerte = () => {
        const url = "api/Liste/ListeDesNiveauxAlertes";
        const paramPost = Scriba.fetch().createParameterPost();
        return fetch(url, paramPost).then(response => response.json());
    };

    static _listeDesNiveauxAlertesParTypeMandat = (idTypeMandat) => {
        const objet = { idTypeMandat };
        const url = "api/Liste/ListeDesNiveauxAlertesParTypeMandat";
        const paramPost = Scriba.fetch().createParameterPost(objet);
        return fetch(url, paramPost).then(response => response.json());
    };

};